import { createDefaultPanel } from 'features/charts-v2/store'
import type { ChartQueryPanel } from 'features/charts-v2/types/chart-query-panel'
import { buildRequestPanel } from 'features/charts-v2/utils/build-request-panel'
import { translateV1FiltersToPanel } from 'features/charts-v2/utils/translate-v1-filters-to-panel'
import type { Filters } from 'types/project'

/**
 * The wire panel for a caller that holds its filters as the v1 `Filters`
 * projection (catalog, PDP): the projection lifted onto a default panel, then
 * lowered to the query fields. A projection with no `create_time` criterion
 * keeps the default panel's date window, exactly as an unscoped page would.
 */
export function buildRequestPanelFromV1Filters(
  filters: Filters,
): ChartQueryPanel {
  const base = createDefaultPanel(0)
  return buildRequestPanel({
    ...base,
    ...translateV1FiltersToPanel(filters, base),
  })
}
